import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import ContainerCard from "./containerCard";
import { useGlobalContext } from "../../utils/globalContext";
import { Chevron } from "@speedoc/design-assets/build/icons/index";
import { Remarkable } from "remarkable";
import { useCallback } from "react";

const markdown = new Remarkable();

const DropdownOverlap = ({ content }) => {
  const [open, setOpen] = useState(undefined);
  const [grow, setGrow] = useState(false);
  const [cardClickable, setCardClickable] = useState(true);
  const [cardPosition, setCardPosition] = useState({});
  const [cardHeight, setCardHeight] = useState(0);
  const { Trans } = useGlobalContext();
  const cardBox = useRef({});
  const expandedCard = useRef();
  useLayoutEffect(() => {
    setCardHeight(cardBox.current.firstChild.offsetHeight);
  }, [cardBox.current.offsetHeight]);

  const resetClick = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        setCardClickable(true);
        resolve();
      }, 900);
    });
  };

  const growCard = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        setGrow(true);
        resolve();
      }, 100);
    });
  };

  const openCard = (e, index) => {
    if (!cardClickable) return;
    setCardClickable(false);
    setOpen(index === open ? undefined : index);
    setCardPosition({ left: e.currentTarget.offsetLeft, top: e.currentTarget.offsetTop });
    growCard().then(resetClick);
  };

  const closeCard = useCallback(() => {
    if (!cardClickable) return;
    setCardClickable(false);
    setGrow(false);
    setTimeout(() => {
      setCardClickable(true);
      setOpen(undefined);
    }, 1000);
  }, [cardClickable]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (open !== undefined && expandedCard.current && !expandedCard.current.contains(event.target)) {
        closeCard();
      }
    };
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, [open, closeCard]);

  return (
    <div id="dropdownOverlap">
      <div className="body">
        <div className="cards" ref={cardBox}>
          {content.map((card, index) => (
            <div key={index} onClick={e => openCard(e, index)}>
              <ContainerCard key={index}>
                <div className="container">
                  <Chevron />
                  <p className="title">
                    <Trans>{card.title}</Trans>
                  </p>
                </div>
              </ContainerCard>
            </div>
          ))}
          {open !== undefined ? (
            <div
              className={`openCardContainer ${grow ? "grow" : ""}`}
              style={{ marginTop: cardPosition.top }}
              onClick={closeCard}>
              <div ref={expandedCard} className={`openCard ${grow ? "grow" : ""}`} style={{ height: cardHeight }}>
                <ContainerCard>
                  <div className="container">
                    <Chevron />
                    <p className="title">
                      <Trans>{content[open].title}</Trans>
                    </p>
                  </div>
                  <p
                    className={`content ${grow ? "fullOpacity" : ""}`}
                    dangerouslySetInnerHTML={{ __html: markdown.render(content[open].content) }}
                  />
                </ContainerCard>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DropdownOverlap;
